<main class="gs">
  <section class="gs__card" [class.gs__card--wide]="reason === 'private'" role="alert">
    <div class="gs__badge" [class.gs__badge--error]="message.tone === 'error'"
         [class.gs__badge--caution]="message.tone === 'caution'"><mat-icon>{{message.icon}}</mat-icon></div>
    <h1 class="gs__title" [innerHTML]="strings[message.title]"></h1>
    <p class="gs__body" [class.gs__body--full]="reason === 'private'" [innerHTML]="strings[message.text]"></p>
    @if (reason === 'private') {
      <ul class="gs__ways">
        @if (authorizeUrl) {
          <li class="gs__way">
            <mat-icon class="gs__way-icon">verified_user</mat-icon>
            <div class="gs__way-main">
              <h2 class="gs__way-title">{{getString('embed_unavailable_authorize_title', authorizeName)}}</h2>
              <p class="gs__way-text">{{strings['embed_unavailable_authorize_text']}}</p>
              <a mat-flat-button color="primary" class="gs__way-action" [href]="authorizeUrl" target="_blank" rel="noopener">
                {{getString('embed_unavailable_authorize_button', authorizeName)}}<mat-icon iconPositionEnd>open_in_new</mat-icon>
              </a>
            </div>
          </li>
        }
        <li class="gs__way">
          <mat-icon class="gs__way-icon">visibility</mat-icon>
          <div class="gs__way-main">
            <h2 class="gs__way-title">{{strings[authorizeUrl ? 'embed_unavailable_share_title' : 'embed_unavailable_share_only_title']}}</h2>
            <p class="gs__way-text">{{strings['embed_unavailable_share_text']}}</p>
            @if (projectUrl) {
              <a mat-stroked-button class="gs__way-action" [href]="projectUrl" target="_blank" rel="noopener">
                {{strings['embed_unavailable_open_project']}}<mat-icon iconPositionEnd>open_in_new</mat-icon>
              </a>
            }
          </div>
        </li>
      </ul>
    }
    @if (showProjectsLink) {
      <div class="gs__actions">
        <a mat-flat-button color="primary" routerLink="/dashboard/projects">{{strings['project_owner_plan_back']}}</a>
      </div>
    }
    @if (reason === 'error') {
      <div class="gs__actions">
        <button mat-flat-button color="primary" type="button" (click)="tryAgain()">
          {{strings['try_again']}}
        </button>
      </div>
    }
  </section>

  <p class="gs__foot">Measure Map Online</p>
</main>
